import { render, staticRenderFns } from "./CommsSettings.vue?vue&type=template&id=68e43997&"
import script from "./CommsSettings.vue?vue&type=script&lang=js&"
export * from "./CommsSettings.vue?vue&type=script&lang=js&"
import style0 from "./CommsSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommsSettings.vue"
export default component.exports